module.exports = __webpack_public_path__ + "static/media/lamina28act1_3.77ba338c.png";